<template>
  <div class="d-flex justify-end">
    <!-- Create folder -->
    <NewFolder ref="newFolder" />

    <v-menu
      max-height="250"
      allow-overflow
      offset-y
      light
    >
      <template #activator="{ on }">
        <v-btn
          light
          v-on="on"
        >
          <v-icon>note_add</v-icon>
          &nbsp; Nouveau
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          @click="createFolder"
        >
          <v-list-item-action class="folder-icon">
            <v-icon>create_new_folder</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dossier</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-for="(item, index) in contentTypes"
          :key="index"
          @click="createContent(contentTypes[index])"
        >
          <v-list-item-avatar class="align-content-center" size="25">
            <v-avatar color="info" size="25">
              <span class="white--text text-capitalize">{{ isAlpha ? item.name[0] : item.configs.wtype[0] }}</span>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue2-helpers/vue-router';
import { useStore } from 'vue2-helpers/vuex';

import NewFolder from './NewFolder.vue';

const { allowedContentTypes } = require('../../utils/permissions');
const { getValidContentTypes } = require('../../utils/content');
// eslint-disable-next-line no-undef
const props = defineProps({
  getDir: {
    type: String,
    default: ''
  }
});

const store = useStore();

const isAlpha = computed(() => store.state.environment.PROJECT === 'alpha');
const router = useRouter();

const { rawContentTypes } = store.state;

const contentTypes = computed(() => {
  let contentTypesList = (getValidContentTypes(rawContentTypes, store.getters.workspace, store.getters.locale) || []).sort((a, b) => {
    if (!isAlpha.value) {
      return 0;
    }

    return a.name.localeCompare(b.name);
  });

  contentTypesList = contentTypesList.filter(a => a !== undefined);

  const { currentUser } = store.state;
  const currentWorkspace = store.getters.workspace;
  const currentProject = store.state.environment.PROJECT;

  contentTypesList = allowedContentTypes(contentTypesList, currentUser.restrictions, currentWorkspace.code, currentProject);

  return contentTypesList;
});

const createContent = contentType => {
  const dir = props.getDir;
  router.push(`/content/${contentType.configs.wtype}?directory=${encodeURIComponent(dir)}`);
};

const newFolder = ref(null);

const createFolder = () => {
  newFolder.value.open(props.getDir);
};

</script>

<style>
  .folder-icon {
    margin-right: 18px !important;
  }
</style>
